import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import './Navbar.scss';

class Navbar extends Component {
  render() {
    const {
      navTitle, leftButton, rightButton, onLeftClick, onRightClick, isRtl, subTitle, className, noTranslate,
    } = this.props;
    const navbarClass = classNames({
      'navbar--rtl': isRtl,
    });

    const leftContent = leftButton ? <button type="button" onClick={onLeftClick}>{leftButton}</button> : <span />;

    return (
      <header className={`navbar ${className} ${navbarClass}`}>
        {leftContent}

        <div className="navbar__title">
          {subTitle && <span className="navbar__subTitle">{subTitle}</span>}
          {navTitle && !noTranslate ? <FormattedMessage id={navTitle} /> : navTitle}
        </div>

        {rightButton && <button type="button" onClick={onRightClick}>{rightButton}</button>}
      </header>
    );
  }
}

// export default withGesture(injectIntl(Navbar));

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Navbar);
